export const HOME = {
  emergentLink: "home-emergent-link",
  navBook: "nav-book-btn",
  heroBook: "hero-book-btn",
  heroSecondary: "hero-secondary-btn",
};

export const BOOKING = {
  form: "booking-form",
  nameInput: "booking-name-input",
  emailInput: "booking-email-input",
  phoneInput: "booking-phone-input",
  notesInput: "booking-notes-input",
  topicFamily: "booking-topic-family",
  topicLegal: "booking-topic-legal",
  topicFinancial: "booking-topic-financial",
  modeOnline: "booking-mode-online",
  modeOffline: "booking-mode-offline",
  calendar: "booking-calendar",
  submit: "booking-submit-btn",
  slotPrefix: "booking-slot-",
};

export const ADMIN = {
  emailInput: "admin-email-input",
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  dashboard: "admin-dashboard",
  appointmentRow: "admin-appt-row-",
  statusSelect: "admin-status-select-",
};

export const MEETING = {
  room: "meeting-room",
  joinBtn: "meeting-join-btn",
};
